import { render, staticRenderFns } from "./Korledare.vue?vue&type=template&id=1f09ae2b&scoped=true&"
import script from "./Korledare.vue?vue&type=script&lang=js&"
export * from "./Korledare.vue?vue&type=script&lang=js&"
import style0 from "./Korledare.vue?vue&type=style&index=0&id=1f09ae2b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f09ae2b",
  null
  
)

export default component.exports